<template>
    <v-container>
        <v-card>
            <v-card-title>
                <h3>Graph List</h3>
            </v-card-title>
            <v-container>
            <v-card-media>
                <v-flex class="row">
                    <div class="col-md-3">
                        <v-btn to="/fake-vs-genuine" color="primary">Fake Vs Genuine</v-btn>
                    </div>
                    <div class="col-md-3">
                        <v-btn to="/certificates-scanned" color="secondary">Certificates Scanned</v-btn>
                    </div>
                    <div class="col-md-3">
                        <v-btn to="/scans-over-time-graph" color="yellow" >Scans Over Time Graph</v-btn>
                    </div>
                </v-flex>
                <v-flex  class="row">
                    <div class="col-md-3">
                        <v-btn to="/dashboard-2021" color="orange" class="text-white">Average Verification Time</v-btn>
                    </div>
                    <div class="col-md-3">
                        <v-btn to="/unsure-results-graph" color="grey" class="text-white">Unsure Results Graph</v-btn>
                    </div>
                    <div class="col-md-3">
                        <v-btn to="/percentage-of-attempts" color="blue" class="text-white">Percentage Of Attempts</v-btn>
                    </div>
                </v-flex>
                <v-flex  class="row">
                  <div   class="col-md-3">
                    <v-btn to="/clients" color="red" class="text-white">Graph By Client</v-btn>
                  </div>
                </v-flex>
            </v-card-media>
        </v-container>
    </v-card></v-container>
</template>

<script>
    export default {
        name: "GraphList"
    }
</script>

<style scoped>

</style>
